import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import type { Exit, ListBox } from "@/components/ui/box.schema";
import { inboxApi, type InboxContext, type InboxPerson } from "@/lib/api/inbox";
import { inboxRead } from "./inbox-read";
import { useCourseInboxExit } from "./CourseMessagingEntry";
import { inboxWords as words } from "./inbox-copy";

/** The course's private messages: each person a teacher can write to, one message visit each. */
export function useCourseMessagesBox(courseId:string):ListBox<InboxContext,InboxPerson> {
  const {me}=useAuth();
  const read=useQuery({queryKey:["inbox",me?.tenant_id,me?.user_id,"context",courseId],queryFn:()=>inboxApi.context(courseId),enabled:Boolean(me),retry:false});
  return box(courseId,read,useCourseInboxExit(courseId));
}

function box(courseId:string,read:ReturnType<typeof useQuery<InboxContext>>,inbox:Exit):ListBox<InboxContext,InboxPerson> {
  return {id:"private-messages",kind:"list",label:words.privateMessages,job:words.readCoursePeople,owner:{system:"imam"},fold:"never",exits:[inbox],
    read:read.data&&!read.data.recipients.length?{status:"empty",sentence:words.noMessagePeople}:inboxRead(read,words.peopleFailed),
    state:()=>({class:"quiet",word:words.privateToTwo}),detail:()=>words.readCoursePeople,
    rows:context=>context.recipients,
    row:{key:person=>person.user_id,title:person=>person.name,state:()=>null,
      facts:person=>[person.role==="instructor"?words.teacher:words.student,...(person.availability!=="available"?[words.personUnavailable(person.name)]:[])].join(" · "),
      act:person=>person.availability==="available"?{does:"visit",verb:words.messagePerson,visit:`thread:${courseId}/${person.user_id}`}:undefined},
  };
}
